<template>
  <div class="changelog-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('changelog_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-math-log</v-icon>{{$t('version.changelog.changelogs')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ChangeLogFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
            <template slot="item.start" slot-scope="{ item }">
              {{ formatDate(item['start'], 'long') }}
            </template>
            <template slot="item.end" slot-scope="{ item }">
              {{ formatDate(item['end'], 'long') }}
            </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ChangeLogFilterForm from '../../components/changelog/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ChangeLogList',
  servicePrefix: 'ChangeLog',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ChangeLogFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('version.changelog.name'), value: 'name' },
        { text: this.$t('version.changelog.type'), value: 'type' },
        { text: this.$t('version.changelog.typevalue'), value: 'valueType' },
        { text: this.$t('version.changelog.developexternal'), value: 'developExternal' },
        { text: this.$t('version.changelog.developer'), value: 'developer.nom' },
        { text: this.$t('version.changelog.start'), value: 'start' },
        { text: this.$t('version.changelog.end'), value: 'end' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['start'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('changelog', {
      items: 'list'
    }),
    ...mapFields('changelog', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('changelog', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
